'use strict';

angular.module('licensure.services')
    .factory('Payments', ['$http', '$q', function ($http, $q) {
        return {

            GetSessionDataForPayment: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/payments/GetSessionDataForPayment', {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getLicenseRequestTotals: function (items) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/payments/GetLicenseRequestTotals', {
                        params: {
                            items: items
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getAttributes: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/payments/getAttributes', {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getPaymentMethods: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/payments/getPaymentMethods', {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getCheckingAccountTypes: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/payments/getCheckingAccountTypes', {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getCreditCardTypes: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/payments/getCreditCardTypes', {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getDebitCardTypes: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/payments/getDebitCardTypes', {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            sign: function (fields) {
                var d = $q.defer();

                $http.post(apiLocation + '/api/payments/sign', fields)
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });
                return d.promise;
            },

            directPayment: function (payment) {
                var d = $q.defer();

                $http.post(apiLocation + '/api/payments/directPayment', payment)
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            preSaveCyberSource: function (fields, args) {
                var d = $q.defer();

                var data = {
                    fields: fields,
                    args: args
                }

                $http({
                    method: 'POST',
                    url: apiLocation + '/api/payments/preSaveCyberSource',
                    data: data
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        d.resolve(null);
                    });

                return d.promise;
            },

            payElavon: function (args) {
                var d = $q.defer();

                $http({
                    method: 'POST',
                    url: apiLocation + '/api/elavon/pay',
                    data: args
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        d.resolve(null);
                    });

                return d.promise;
            }
        }
    }])
    ;